import { QueryString, initMapDark } from '../functions';

$(document).ready(function() {

	const vehiclesList = {
        isLoading: false,
        map: null,
        init() {
            $(document).on('change', '#manufacturer', this, this.selectManufacturer);
            $(document).on('change', '#mobile-manufacturer', this, this.selectManufacturerMobile);
            $(document).on('click', '#filter-vehicles', this, this.filter);
            $(document).on('click', '#mobile-filter-vehicles', this, this.mobileFilter);
            $(document).on('click', '.sort-vehicles', this, this.sort);
            $(document).on('click', '.vehicle-request-offer-btn', this, this.showRequestOfferModal);
            $(document).on('click', '#vehicle-request-offer-send-btn', this, this.requestOffer);
            $(document).on('click', '#vehicle-request-offer-send-btn-inline', this, this.requestOffer);
            $(document).on('click', '#vehicles-show-filters', this, this.showFiltersMobile);

			$(window).scroll(function() {
				// if (($(document).scrollTop() > 330) ) { //&& (($(document).scrollTop() + 660) < 1 * $('.car-list-wrapper').height())
				// 	$('.vehicles-list-filters-wrapper').addClass('filter-fixed');
				// } else {
				// 	$('.vehicles-list-filters-wrapper').removeClass('filter-fixed');
				// }
		    });

			if (this.map == null) {
				this.map = true;
				initMapDark('vehicles-contact-map');
			}
        },
		showFiltersMobile(event) {
			const _this = event.data;
			event.preventDefault();

			if($('.auto-rulate-mobile-filters').css('display') == 'block') {
				$('.auto-rulate-mobile-filters').css('display', 'none');
			} else {
				$('.auto-rulate-mobile-filters').css('display', 'block');
				window.scrollTo(0, 0);
			}
		},
		requestOffer(event) {
			const _this = event.data;
			event.preventDefault();

			let id = $(this).data('id');
			if (!id || id == '' || id == null) {
				console.error('Invalid id!');
				return false;
			}

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			//$('#vehicle-request-offer').find('.form-control').removeClass('is-invalid');
			$('#offer-form').find('.form-control').removeClass('is-invalid');
			$('#vro-notifications').html('');

			if ($('#vr_first_name').val() == '') {
				$('#vr_first_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#vr_last_name').val() == '') {
				$('#vr_last_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#vr_email').val() == '') {
				$('#vr_email').addClass('is-invalid');
				errors = true;
			}
			if ($('#vr_phone').val() == '') {
				$('#vr_phone').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#vro-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'id=' + id;
			values += '&first_name=' + $('#vr_first_name').val();
			values += '&last_name=' + $('#vr_last_name').val();
			values += '&email=' + $('#vr_email').val();
			values += '&phone=' + $('#vr_phone').val();
			values += '&message=' + $('#vr_message').val();
			values += '&_token=' + $('#_token_vro').val();
			$.ajax({
	            type: "POST",
	            url: vehiclesRequestOfferSendRoute,
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#vr_' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						$('#vro-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
                        return false;
                    }

					if (response.status == 1) {
						// $('#vehicle-request-offer').modal('hide');
						// $('#vehicle-request-offer').on('hidden.bs.modal', function() {
						// 	$('#vehicle-request-offer-container').html('');
						// });

						$('#vr_first_name').val('');
						$('#vr_last_name').val('');
						$('#vr_email').val('');
						$('#vr_phone').val('');
						$('#vr_message').val('');

						$('#vro-notifications').html('<div class="alert alert-success" role="alert">Cererea dumneavoastră a fost trimisă.</div>');

						if (cookies_advertisement == 1 || cookies_social == 1) {
							fbq('track', 'Lead');
						}

						return false;
					}

					$('#vro-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		},
		showRequestOfferModal(event) {
			const _this = event.data;
			event.preventDefault();

			let id = $(this).data('id');
			if (!id || id == '' || id == null) {
				console.error('Invalid id!');
				return false;
			}

			if (_this.isLoading) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'id=' + id;
			$.ajax({
	            type: "GET",
	            url: vehiclesRequestOfferModalRoute,
	            data: values,
	            success: function(response) {
					$('#vehicle-request-offer-container').html(response);
					$('#vehicle-request-offer').modal('show');
					_this.isLoading = false;
					$(element).find('i').hide();
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		},
		sort(event) {
			const _this = event.data;
			event.preventDefault();

			let query = '';

			if (QueryString(null).m) {
				if (query == '') {
					query = '?m=' + QueryString(null).m;
				} else {
					query += '&m=' + QueryString(null).m;
				}
		    }
			if (QueryString(null).mm) {
				if (query == '') {
					query = '?mm=' + QueryString(null).mm;
				} else {
					query += '&mm=' + QueryString(null).mm;
				}
		    }
			if (QueryString(null).fuel) {
				if (query == '') {
					query = '?fuel=' + QueryString(null).fuel;
				} else {
					query += '&fuel=' + QueryString(null).fuel;
				}
		    }
			if (QueryString(null).trans) {
				if (query == '') {
					query = '?trans=' + QueryString(null).fuel;
				} else {
					query += '&trans=' + QueryString(null).fuel;
				}
		    }
			if (QueryString(null).fkm) {
				if (query == '') {
					query = '?fkm=' + QueryString(null).fkm;
				} else {
					query += '&fkm=' + QueryString(null).fkm;
				}
		    }
			if (QueryString(null).tkm) {
				if (query == '') {
					query = '?tkm=' + QueryString(null).tkm;
				} else {
					query += '&tkm=' + QueryString(null).tkm;
				}
		    }
			if (QueryString(null).fyear) {
				if (query == '') {
					query = '?fyear=' + QueryString(null).fyear;
				} else {
					query += '&fyear=' + QueryString(null).fyear;
				}
		    }
			if (QueryString(null).tyear) {
				if (query == '') {
					query = '?tyear=' + QueryString(null).tyear;
				} else {
					query += '&tyear=' + QueryString(null).tyear;
				}
		    }

			if (query == '') {
				query = '?sort=' + $(this).data('sort');
			} else {
				query += '&sort=' + $(this).data('sort');
			}

			window.location = vehiclesListRoute + query;
		},
		filter(event) {
			const _this = event.data;
			event.preventDefault();

			let query = '';

			if ($('#manufacturer option:selected').val() != '') {
				if (query == '') {
					query = '?m=' + $('#manufacturer option:selected').val();
				} else {
					query += '&m=' + $('#manufacturer option:selected').val();
				}
			}
			if ($('#model option:selected').val() != '') {
				if (query == '') {
					query = '?mm=' + $('#model option:selected').val();
				} else {
					query += '&mm=' + $('#model option:selected').val();
				}
			}
			if ($('#fuel option:selected').val() != '') {
				if (query == '') {
					query = '?fuel=' + $('#fuel option:selected').val();
				} else {
					query += '&fuel=' + $('#fuel option:selected').val();
				}
			}
			if ($('#trans option:selected').val() != '') {
				if (query == '') {
					query = '?trans=' + $('#trans option:selected').val();
				} else {
					query += '&trans=' + $('#trans option:selected').val();
				}
			}
			if ($('#from-km option:selected').val() != '') {
				if (query == '') {
					query = '?fkm=' + $('#from-km option:selected').val();
				} else {
					query += '&fkm=' + $('#from-km option:selected').val();
				}
			}
			if ($('#to-km option:selected').val() != '') {
				if (query == '') {
					query = '?tkm=' + $('#to-km option:selected').val();
				} else {
					query += '&tkm=' + $('#to-km option:selected').val();
				}
			}
			if ($('#from-year option:selected').val() != '') {
				if (query == '') {
					query = '?fyear=' + $('#from-year option:selected').val();
				} else {
					query += '&fyear=' + $('#from-year option:selected').val();
				}
			}
			if ($('#to-year option:selected').val() != '') {
				if (query == '') {
					query = '?tyear=' + $('#to-year option:selected').val();
				} else {
					query += '&tyear=' + $('#to-year option:selected').val();
				}
			}

			window.location = vehiclesListRoute + query;
		},
		mobileFilter(event) {
			const _this = event.data;
			event.preventDefault();

			let query = '';

			if ($('#mobile-manufacturer option:selected').val() != '') {
				if (query == '') {
					query = '?m=' + $('#mobile-manufacturer option:selected').val();
				} else {
					query += '&m=' + $('#mobile-manufacturer option:selected').val();
				}
			}
			if ($('#mobile-model option:selected').val() != '') {
				if (query == '') {
					query = '?mm=' + $('#mobile-model option:selected').val();
				} else {
					query += '&mm=' + $('#mobile-model option:selected').val();
				}
			}
			if ($('#mobile-fuel option:selected').val() != '') {
				if (query == '') {
					query = '?fuel=' + $('#mobile-fuel option:selected').val();
				} else {
					query += '&fuel=' + $('#mobile-fuel option:selected').val();
				}
			}
			if ($('#mobile-trans option:selected').val() != '') {
				if (query == '') {
					query = '?trans=' + $('#mobile-trans option:selected').val();
				} else {
					query += '&trans=' + $('#mobile-trans option:selected').val();
				}
			}
			if ($('#mobile-from-km option:selected').val() != '') {
				if (query == '') {
					query = '?fkm=' + $('#mobile-from-km option:selected').val();
				} else {
					query += '&fkm=' + $('#mobile-from-km option:selected').val();
				}
			}
			if ($('#mobile-to-km option:selected').val() != '') {
				if (query == '') {
					query = '?tkm=' + $('#mobile-to-km option:selected').val();
				} else {
					query += '&tkm=' + $('#mobile-to-km option:selected').val();
				}
			}
			if ($('#mobile-from-year option:selected').val() != '') {
				if (query == '') {
					query = '?fyear=' + $('#mobile-from-year option:selected').val();
				} else {
					query += '&fyear=' + $('#mobile-from-year option:selected').val();
				}
			}
			if ($('#mobile-to-year option:selected').val() != '') {
				if (query == '') {
					query = '?tyear=' + $('#mobile-to-year option:selected').val();
				} else {
					query += '&tyear=' + $('#mobile-to-year option:selected').val();
				}
			}

			window.location = vehiclesListRoute + query;
		},
		selectManufacturer(event) {
			const _this = event.data;
    		let id = this.value;

			var values = 'id=' + id;
			$.ajax({
	            type: "GET",
	            url: baseURL + "/manufacturer/get-models",
	            data: values,
	            success: function(models) {
					$('#model').find('option:not(:first)').remove();

					for(var i in models) {
						$('#model').append('<option value="'+models[i].id+'" '+(selectedModel == models[i].id ? 'selected="selected"' : '')+'>'+models[i].name+'</option>');
					}
	            }
	        });
		},
		selectManufacturerMobile(event) {
			const _this = event.data;
    		let id = this.value;

			var values = 'id=' + id;
			$.ajax({
	            type: "GET",
	            url: baseURL + "/manufacturer/get-models",
	            data: values,
	            success: function(models) {
					$('#mobile-model').find('option:not(:first)').remove();

					for(var i in models) {
						$('#mobile-model').append('<option value="'+models[i].id+'" '+(selectedModel == models[i].id ? 'selected="selected"' : '')+'>'+models[i].name+'</option>');
					}
	            }
	        });
		}
    };

    if ($('#auto-rulate-wrapper').length) {
        vehiclesList.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/vehicles-list.js